import React from 'react'

import { CustomField } from '../../CustomField'

import './CustomFieldSingle.less'

export function CustomFieldSingle({ field, fields, onChangeValue, errors, value, isReadOnly, isPreview }) {
  return (
    <div className="CustomFieldSingle__input">
      <CustomField
        key={field.id}
        field={field}
        setValues={onChangeValue}
        errors={errors}
        value={value}
        isReadOnly={isReadOnly || isPreview}
        groupFields={fields}
      />
    </div>
  )
}
